export default "__VITE_ASSET__BX6h_gjV__"